<div class="container">
  <form *ngIf="country !== 'NZ'" [formGroup]="memberTypeForm">
    <h1>{{ labels.MEMBER_TYPE_HEADER }}</h1>
    <p>{{ labels.MEMBER_TYPE_DESCRIPTION }}</p>
      <div class="flexRow">
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{ labels.MEMBER_TYPE_FIRST_NAME }}</mat-label>
            <input matInput formControlName="firstName" />
            <mat-error>
              {{ labels.MEMBER_TYPE_FIRST_NAME_ERROR }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{ labels.MEMBER_TYPE_LAST_NAME }}</mat-label>
            <input matInput formControlName="lastName" />
            <mat-error>
              {{ labels.MEMBER_TYPE_LAST_NAME_ERROR }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flexRow">
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{ labels.MEMBER_TYPE_CARD_NO }}</mat-label>
            <input matInput formControlName="cardNo" maxlength="13" />
            <mat-error>
              {{ labels.MEMBER_TYPE_CARD_NO_ERROR }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flexColumn">
          <mat-form-field>
            <mat-label>{{ labels.MEMBER_TYPE_DOB }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="picker"
              readonly
              (click)="picker.open()"
              formControlName="dob"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker disabled="false"></mat-datepicker>
            <mat-error>{{ labels.MEMBER_TYPE_DOB_ERROR }}</mat-error>
          </mat-form-field>
        </div>

      </div>
        <button
          mat-raised-button color="accent" class="submitButton"
          [disabled]="!memberTypeForm.valid"
          (click)="submitExistingMemberDetails()"
        >
          {{ labels.MEMBER_TYPE_SUBMIT }}
        </button>

      <div class="nonMemberActions">
        <h1>{{ labels.NOT_MEMBER }}</h1>
        <button
          mat-raised-button color="accent" class="continueButton"
          (click)="resetExistingMemberDetails();memberTypeClick.emit()">
          {{ labels.MEMBER_TYPE_CONTINUE }}
        </button>
      </div>
  </form>
  <mat-card *ngIf="country === 'NZ'">
    <mat-card-header>
      <mat-card-title>Everyday Rewards Plus Card Activation</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p *ngIf="countdown > 0">
        For Everyday Rewards Plus card activation, Everyday Rewards account management will open in a new tab in {{ countdown }} seconds.
      </p>

      <p *ngIf="popUpsEnabled === false">To proceed, please allow popups for our website in your browser settings.</p>

      <div *ngIf="popUpsEnabled && !closedManually">
        <p>We are waiting for your response...</p>
        <mat-spinner></mat-spinner>
        <p class="info-message">If you don't see a popup window, please check your browser's popup settings or try refreshing the page. </p>
      </div>


      <p *ngIf="closedManually">
        It seems the window was closed prematurely. Please try again.
      </p>
    </mat-card-content>
    <mat-card-actions>
      <button *ngIf="closedManually" color="accent" mat-raised-button (click)="initiateEdrLogin()">Retry</button>
      <button *ngIf="popUpsEnabled === false" color="accent" mat-raised-button (click)="initiateEdrLogin()">Enable Popups and Retry</button>
    </mat-card-actions>
  </mat-card>


</div>
